export default __webpack_public_path__ + "static/media/river_sprite_card.90b83c14.png";